// All widgets take id, surveyName, selectedGroupName, organizationName, loading and testMode as props.
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    deregisterWidget: {
      type: Function,
      default: null
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    hasResults: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    updateWidgetSliderState: {
      type: Function,
      default: null
    },
    organizationName: {
      type: String,
      default: ''
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    surveyName: {
      type: String,
      default: ''
    },
    surveyIsAggregate: {
      type: Boolean,
      default: false
    },
    // TODO: replace only aggregates are migrated
    surveyIsAggregateV2: {
      type: Boolean,
      default: false
    },
    selectedGroup: {
      type: Object,
      default: () => {}
    },
    selectedAttributeSegment: {
      type: Object,
      default: () => {}
    },
    selectedGroupName: {
      type: String,
      default: ''
    },
    selectedGroupTitle: {
      type: String,
      default: ''
    },
    widgetSliderState: {
      type: Object,
      default: {}
    },
    testMode: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    viewMode: {
      type: String,
      default: 'default'
    },
    userIsGroupAdmin: {
      type: Boolean,
      default: false
    },
    userIsPulsAdmin: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  }
}
